/**
 * Set no-store if you want to prevent caching. More reliable (and preferred) to max-age=0.
 * Atm, public doesn't do anything
 */
export enum Cacheability {
  Public = 'public',
  NoStore = 'no-store'
}

export enum Revalidation {
  MustRevalidate = 'must-revalidate',
  ProxyRevalidate = 'proxy-revalidate'
}
